var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHideIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_652_256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6551 13.6569C16.7793 10.5327 16.7793 5.46734 13.6551 2.34315C10.5309 -0.781049 5.46562 -0.781048 2.34142 2.34315C-0.78277 5.46734 -0.78277 10.5327 2.34142 13.6569C5.46562 16.781 10.5309 16.781 13.6551 13.6569Z",
    fill: "#6AAF50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.956 8.39067C11.6992 9.73442 9.89253 10.5063 8.00003 10.5063C7.38764 10.5054 6.778 10.4246 6.18659 10.2657L7.01253 9.43755C7.31498 9.60375 7.65492 9.68981 8.00003 9.68755C9.01509 9.68755 9.84096 8.97505 9.84096 8.09692C9.84096 7.70005 9.67159 7.33755 9.39218 7.05942L10.3585 6.0938C11.3319 6.43083 12.2161 6.98431 12.9447 7.71255C13.0361 7.80098 13.0886 7.92211 13.0907 8.04928C13.0929 8.17644 13.0444 8.29925 12.956 8.39067ZM6.65909 8.09692C6.65909 8.3563 6.77184 8.59692 6.95931 8.78442L8.6149 7.12817C8.42016 7.04681 8.21108 7.00537 8.00003 7.0063C7.26062 7.0063 6.65921 7.49692 6.65921 8.09692H6.65909ZM9.34093 8.09692C9.34093 7.83755 9.22803 7.59692 9.04028 7.40942L7.3849 9.06567C7.57973 9.14704 7.7889 9.18848 8.00003 9.18755C8.7394 9.18755 9.34106 8.70005 9.34106 8.09692H9.34093ZM3.04406 8.39067C3.76476 9.15715 4.65764 9.74097 5.64881 10.0938L6.60753 9.13755C6.32846 8.8563 6.15915 8.4938 6.15906 8.09692C6.15906 7.22192 6.98503 6.5063 8.00003 6.5063C8.34494 6.50561 8.68449 6.59158 8.98753 6.7563L9.81718 5.92817C9.22432 5.77056 8.61348 5.69072 8.00003 5.69067C6.13721 5.69067 4.33481 6.42817 3.05534 7.71255C3.01006 7.75633 2.97386 7.80861 2.94879 7.86639C2.92372 7.92417 2.91028 7.98632 2.90924 8.04929C2.90821 8.11227 2.91959 8.17483 2.94273 8.23341C2.96588 8.29198 3.00034 8.34542 3.04415 8.39067H3.04406Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_652_256"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideIcon);
export default __webpack_public_path__ + "static/media/hideIcon.c034a1ee4591077d30ef4f5ae61d328c.svg";
export { ForwardRef as ReactComponent };